import { getCurrentUsersPlan } from '@/lib/getCurrentUsersPlan'
import { UserContext } from '@/lib/UserContext'
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'

type CalloutBlockProps = {
  heading?: string
  subheading?: string
  paywall?: boolean
  visible_to: { handle: string }[]
  paywall_message?: string
  buttons: {
    button_text: string
    button_url: string
    button_target_blank: boolean
  }[]
}

export const CalloutBlock: React.FC<CalloutBlockProps> = (
  props
): JSX.Element => {
  const user = useContext(UserContext)
  const userData = user({ guarded: false })
  const userPlan = userData
    ? getCurrentUsersPlan(userData, { format: 'id' })
    : null
  const visibleTo = props.visible_to.map(item => item.handle)
  const contentHidden = props.paywall && !visibleTo.includes(userPlan ?? 'none')

  const router = useRouter()
  const redirectTo = `?redirectTo=${router.asPath}`

  return (
    <Container maxW='4xl'>
      <Box textAlign='center' p={8} background='gray.100' borderWidth='2px'>
        {props.heading || props.subheading ? (
          <Box mb={4}>
            {props.heading ? <Heading>{props.heading}</Heading> : null}
            {props.subheading ? <Text as='h3'>{props.subheading}</Text> : null}
          </Box>
        ) : null}
        {contentHidden ? (
          <Stack gap={4} pt={4} align='center'>
            <Box
              backgroundColor='yellow.700'
              px={4}
              py={1}
              display='inline-block'
              fontWeight='bold'>
              {props.paywall_message ??
                'You will need to login to access this content'}
            </Box>
            <Flex justify='center' gap={2} align='center'>
              {!userData ? (
                <>
                  <Button colorScheme='red' as='a' href={`/login${redirectTo}`}>
                    Login
                  </Button>
                  <Text as='span' fontWeight='bold'>
                    or
                  </Text>
                </>
              ) : null}
              <Button colorScheme='red' as='a' href={`/register${redirectTo}`}>
                {!userData ? 'Sign Up' : 'Upgrade'}
              </Button>
            </Flex>
          </Stack>
        ) : (
          <Flex gap={4} flexWrap='wrap' justify='center'>
            {props.buttons.map(button => (
              <Button
                colorScheme='red'
                as='a'
                key={button.button_url}
                href={button.button_url}
                target={button.button_target_blank ? '_blank' : undefined}>
                {button.button_text}
              </Button>
            ))}
          </Flex>
        )}
      </Box>
    </Container>
  )
}
